document.addEventListener('DOMContentLoaded', function () {
    function updateButtonState(checkboxes, actionButtons) {
        const firstChecked = checkboxes[0].checked;
        const secondChecked = checkboxes[1].checked;
        const thirdChecked = checkboxes[2].checked;
        const fourthChecked = checkboxes[3].checked;
        let enable = false;
        if (firstChecked) {
            enable = secondChecked && thirdChecked && fourthChecked;
        } else {
            enable = secondChecked && fourthChecked;
        }
        actionButtons.forEach(btn => {
            btn.style.pointerEvents = enable ? 'auto' : 'none';
            btn.style.opacity = enable ? '1' : '0.5';
        });
    }
    // Only run if body has class 'cmp-powerportal-main'
    if (!document.body.classList.contains('cmp-powerportal-main')) {
        return;
    }
    const overlay = document.getElementById('terms-overlay');
    const termsContainer = document.querySelector('.terms__container');
//.cmp-header__login .cmp-button
    const contactElements = document.querySelectorAll('.cmp-header__login .cmp-button');
    contactElements.forEach(function(element) {
        element.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (overlay && termsContainer) {
                const isVisible = termsContainer.style.display === 'block';
                if (isVisible) {
                    overlay.style.display = 'none';
                    termsContainer.style.display = 'none';
                } else {
                    overlay.style.display = 'block';
                    termsContainer.style.display = 'block';
                }
            }
        });
    });

    if (overlay && termsContainer) {
        overlay.addEventListener('click', function() {
            overlay.style.display = 'none';
            termsContainer.style.display = 'none';
        });
        const closeBtn = termsContainer.querySelector('.terms__close');
        if (closeBtn) {
            closeBtn.addEventListener('click', function() {
                overlay.style.display = 'none';
                termsContainer.style.display = 'none';
            });
        }
    }
    const checkboxes = document.querySelectorAll(
      'input[type="checkbox"][name^="termsandconditions-checkbox-"]'
    );
    if (checkboxes.length > 0) {
        const selectAllCheckbox = checkboxes[0];
        const actionButtons = document.querySelectorAll('.terms__action-button');
        actionButtons.forEach(btn => {
            btn.style.pointerEvents = 'none';
            btn.style.opacity = '0.5';
        });
        selectAllCheckbox.addEventListener('change', function () {
            checkboxes.forEach((cb, idx) => {
                if (idx !== 0) {
                    cb.checked = selectAllCheckbox.checked;
                }
            });
            updateButtonState(checkboxes, actionButtons);
        });
        checkboxes.forEach((cb, idx) => {
            if (idx !== 0) {
                cb.addEventListener('change', function () {
                    // Update selectAllCheckbox state
                    selectAllCheckbox.checked = checkboxes[1].checked && checkboxes[2].checked && checkboxes[3].checked;
                    updateButtonState(checkboxes, actionButtons);
                });
            }
        });
                
        // Check initial state on page load (for browser back navigation)
        updateButtonState(checkboxes, actionButtons);
    }
});
